import React from 'react';

import MultiPageForm from "../Base/ReactMultiPageForm";
import UserInput from "../UI/ReactUserInput";
import ChildProgressReviewPanelLegacy from "./ReactChildProgressReviewPanelLegacy";

export default class ChildProgressReviewAchievementLegacy extends MultiPageForm
{
	static get defaultProps() 
	{
	    return 
	    {
	      { 
	    	  prevButtonRequired: true ;
	      	  nextButtonRequired: true ;
	    	  mode: 'create'; 
	          userid: '' ; 
	          usertype:0; 
	          title: "" }
	    } ;
	}
	    
	constructor(props) 
	{
		super(props);

		this.state.data = this.props.data ;
		this.state.isDirty = false ;
		this.state.review_id = this.props.review_id;
		this.state.mode = this.props.mode ;
		this.state.loading = true ;

		this.keyCount = 1 ;

		this.onDeleteSubject = this.onDeleteSubject.bind(this) ;
		this.onSave = this.onSave.bind(this) ;
        this.getReviewData = this.getReviewData.bind(this) ;

	}

    componentDidMount()
    {
        this.getReviewData ( this.props.review_id ) ;
    }

	updateReviewRecords ( reviewData )
	{
		// Globals are defined in the globals.js class
		var url = Globals.APIFolder + '/children/' + this.props.child_id+ '/review/' + this.props.review_id + '/achievements' ;
		
		var data = { review_data: reviewData } ; 
		
    	$.ajax({
  		  type: 'POST',
  		  url: url ,
  		  data: data,
  		  success:(data)=>{
  			  
  				// Call the whole thing off		
  				if ( checkError(data))
  				{
  					this.getReviewData(this.props.review_id ) ;
  				}
  		  },
  		  error:function(jqXHR, textStatus, error){
				handleAjaxError(jqXHR, textStatus, error) ;
  		  }
  		});
	}

    // This function creates the review record structure from the child's template and returns the data
    // created ready to e displayed on the forms
    getReviewData ( review_id )
    {
        // Globals are defined in the globals.js class
        var root = Globals.APIFolder ;

        var data = { } ;

        $.ajax({
            type: 'GET',
            url: root + '/reviews/'+review_id+'/achievements' ,
            data: data,
            success:(data)=>{

                // We've got something back, so set the data field in the REACT component STATE
                // THis will be used in the RENDER function

				if ( this.props.data_element_name == 'achievement')
				{
					let d = { members: [] }; ;

					if ( data.data.achievement != null )
					{
                        d = data.data.achievement ;
					}

					this.setState({ data: d, loading: false, dirty: false }) ;
				}
				else
				{
                    let d = { members: [] };

                    this.setState({ data: d, loading: false, dirty: false }) ;
				}

            },
            error:(jqXHR, textStatus, error)=>{

               handleAjaxError(jqXHR, textStatus, error ) ;
            }
        });

    }


	onLeave()
	{
		if ( this.props.autoSave == true )
		{
			if (this.formIsValid())
			{
				this.autoSave() ;		
			}
		}
	}	
	
	autoSave()
	{
		if ( this.isDirty() )
		{
			this.doSave() ;			
		}
	}

	isDirty()
	{
		var result = false ;

       	var i = 0 ;
        
        // Iterate through all the child controls to test each is reporting itself valid
        for (var key in this.refs) 
        {
        	var obj = this.refs[key] ;
        	
			if ( typeof obj.isDirty === 'function' )
			{
				if ( obj.isDirty())
				{
					result = true ;
				}
			}    	      
    	}

        if ( this.state.isDirty == true )
		{
			result = true ;
		}

		return result ;
	}	
	
	setDirty( value )
	{
       	var i = 0 ;
        
        // Iterate through all the child controls to test each is reporting itself valid
        for (var key in this.refs) 
        {
        	var obj = this.refs[key] ;
        	
			if ( typeof obj.setDirty === 'function' )
			{
				obj.setDirty(value) ;
			}    	      
    	}

        if ( value == false )
        {
            if ( this.props.setDirty != null )
            {
                this.props.setDirty(value) ;
            }

			this.setState ({isDirty: value}) ;
        }

    }

	doSave()
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var reviewData = {} ;

			reviewData[this.props.data_element] = this.getFormData() ;			
			reviewData.progress_review_id = this.props.review_data.progress_review_id ;
			reviewData.child_id = this.props.child_id ;

			this.updateReviewRecords (reviewData) ;

			this.setDirty( false ) ;
		}
	}
		
	getFormData()
	{
		let newData = [] ;

        for (var key in this.refs)
        {
            var obj = this.refs[key] ;

            if ( typeof obj.getFormData === 'function' )
            {
                newData.push ( obj.getFormData()) ;
            }
        }

		var entire = this.state.data ;

		entire.members = newData ;

		return entire ;
	}

	formIsValid ()
	{
       	var i = 0 ;
        
        // Iterate through all the child controls to test each is reporting itself valid
        for (var key in this.refs) 
        {
        	var obj = this.refs[key] ;
        	
			if ( typeof obj.isValid === 'function' )
			{
			  if ( !obj.isValid())
			  {
				  return false ;
			  }    	      
			}    	      
    	}
        
		return true ;
	}
	
	onSave() 
	{
		if ( !this.formIsValid())
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			if ( this.props.onSave != null )
			{
				// Just pass the click back to the creating form
				this.props.onSave() ;
			}	
		}
	}
	
	onSaveNewSubject() 
	{
		if ( !this.refs.InputNewSubjectName.isValid()) 
		{
			this.setState ( { displayErrors : true })
		}
		else
		{
			var newName = this.refs.InputNewSubjectName.getValue() ;

			this.addNewPanel ( newName ) ;
		}
	}

	onCancel() 
	{
		if ( this.props.onCancel != null )
		{
			this.props.onCancel() ;
		}
		else
		{
			location.assign('home.php');
		}
	}

	getFormattedDate(date) 
	{
		  var year = date.getFullYear();
		  var month = (1 + date.getMonth()).toString();
		  month = month.length > 1 ? month : '0' + month;
		  var day = date.getDate().toString();
		  day = day.length > 1 ? day : '0' + day;
		  return day + '/' + month + '/' + year;
	}
		
	buttonElement ( buttonText, clickHandler )
	{
        return React.createElement('button', { id: 'getButtonReact', type: 'button', className: 'btn btn-primary', onClick: clickHandler }, buttonText) ;
	}
		
	buttonRow ()
    {
        var lineList=[];

		if ( this.state.mode == 'addpanel')
		{
			if ( this.state.mode != 'view' )
			{
				lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-6', style: {  }},        		 
						React.createElement( UserInput, { validation: { required: true, maxlen: 45},
      			  id: 'InputNewSubjectName', 
      			  name: 'InputNewSubjectName',
      			  ref: 'InputNewSubjectName',
      			  labelText: 'New Subject', 
      			  errorText: 'You must enter a new subject name',
      			  value: '',
      			  readOnly: false, 
      			  displayErrors:this.state.displayErrors,
      			  key: this.keyCount++
      			  }))) ;

			}
			else
			{
				lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-6'})) ;
			}

			lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-6', style: { }},
					 React.createElement('button', { id: 'SaveButton', type: 'button', className: 'btn btn-primary', style: { float: 'right', marginTop: '25px' } , onClick: this.onSaveNewSubject.bind(this) }, 'Save New Subject'),
					 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '10px', marginTop: '25px' }, onClick: this.onCancelAdd.bind(this) }, 'Cancel Add')))

		}
		else
		{
			if ( this.props.mode == 'view')
			{
				lineList.push ( React.createElement ( 'div',{key: this.keyCount++,className: 'col-md-9'},null)) ;

				lineList.push ( React.createElement ( 'div',{key: this.keyCount++, className: 'col-md-3', style: { paddingRight: '0px'}},
						 React.createElement('button', { id: 'CancelButton', type: 'button', className: 'btn btn-secondary', style: {float: 'right', marginRight: '0px' }, onClick: this.onCancel.bind(this) }, 'Close')))

			}
			else
			{
				if ( this.state.data.progress_review_add_allowed == 1)
				{
				lineList.push ( React.createElement ( 'div', { key: this.keyCount++, className: 'col-md-12', style: { paddingLeft: '15px' }},        		 
						React.createElement('button', { id: 'AddButton', type: 'button', className: 'btn btn-info', style: { float: 'left' } , onClick: this.onAdd.bind(this) }, 'Add a new Area'))) ;
					
				}
			}
		}
           		        
        return React.createElement('div', { key: this.keyCount++, className: 'row' }, lineList ); 
    }

	onCancelAdd() 
	{
		this.setState ({ mode: this.state.prevMode }) ;
	}

	onAdd() 
	{
		var curMode = this.state.mode ;

		this.setState ({ mode: 'addpanel', prevMode: curMode }) ;
	}

	addNewPanel ( panelName )
	{
		var currentData = this.state.data ;

		var currentMembers = currentData.members ;
		
		var newOne = {} ;

		newOne.review_id = this.state.review_id ;
		newOne.description = panelName ;
		newOne.achievement_id = 0 ;
		newOne.assessment = 0 ;
		newOne.attitude = 0 ;
		newOne.progress_achieved = '#' ;
		newOne.scope = '' ;
		newOne.strengths = '' ;
		newOne.areas_for_development = '' ;
		newOne.allow_delete = true ;
		newOne.new = true ;

		currentMembers.push ( newOne ) ;

		currentData.members = currentMembers ;

		// Tell the form something has changed
		this.onDirty() ;

		this.setState ( { data: currentData, mode: this.state.prevMode, isDirty: true  }) ;
	}

	removeAchievementByName ( name )
	{
        let current_data = this.state.data ;

        current_data.members = current_data.members.filter(function(element)
        {
            if ( element.description == name && ( element.achievement_id == 0 || element.achievement_id == null) )
            {
                return false ;
            }
            else {
                return true ;
            }
        });

        this.setState ( { data: current_data }) ;
	}

    doDeleteAchievement ( achievement_id )
    {
        // Globals are defined in the globals.js class
        var url = Globals.APIFolder + '/reviews/' + this.props.review_id + '/achievements/' + achievement_id ;

        $.ajax({
            type: 'DELETE',
            url: url ,
            data: {},
            async: false,
            beforeSend:function(){
                // this is where we append a loading image
            },
            success:(data)=>{
            if ( checkError(data))
			{
				this.getReviewData(this.props.review_id ) ;
			}
		},
			error:function(jqXHR, textStatus, error){
				handleAjaxError(jqXHR, textStatus, error) ;
			}
		});
    }

	onDeleteSubject( achievement )
	{
		let message = "You are about to delete this subject from the pupil's Progress Review. This will also remove the subject from future reviews. Are you sure you want to delete this subject?"
        var me  = this ;
        bootbox.confirm({
            message: message,
            buttons: {
                confirm: {
                    label: 'Yes, delete the subject',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-default'
                }
            },
            callback: function (result)
            {
            	if ( result == true )
				{
					if ( achievement.achievement_id != 0 )
					{
                        me.doDeleteAchievement( achievement.achievement_id ) ;
					}
					else
					{
						me.removeAchievementByName ( achievement.description ) ;
					}
				}
            }
        });
    }

	formRows ()
    {
        var lineList = [];

        var x;

        if (this.state.data != null && this.state.data.members != null)
		{
            for (x in this.state.data.members) {
                var obj = this.state.data.members[x];

                lineList.push(React.createElement(ChildProgressReviewPanelLegacy, {
                    key: 'Panel' + obj.achievement_id + obj.description,
                    mode: this.state.mode,
                    review_id: this.state.review_id,
                    year_id: this.props.year_id,
                    data: obj,
                    panelNumber: x,
                    onDelete: this.onDeleteSubject,
                    progressAchievedRequired: this.props.progressAchievedRequired,
                    displayErrors: this.state.displayErrors,
                    onDirty: this.onDirty,
                    ref: 'Panel' + obj.achievement_id + obj.description,
                }));
            }
    	}

        if ( this.state.mode == 'addpanel' || this.state.data.progress_review_add_allowed == 1 )
		{
			// Don't display the button row if we're not going to put anything in it
			lineList.push ( React.createElement('div', { key: this.keyCount++, className: 'panel-body', style: {paddingLeft: '15px'}}, this.buttonRow())) ;
		}

		lineList.push(this.navFormRow()) ;

		
		return lineList ;
	}
	
	render() 
    {
		this.keyCount=0;

        if ( this.state.loading == true )
        {
            return React.createElement('div', { key: this.keyCount++, className: ''}, "LOADING...");
        }
        else {
            return React.createElement('div', {
                key: this.keyCount++,
                className: 'panel panel-default panel-academic'
            }, this.formRows());
        }
    }
};